(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ebd-product-checklist"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('.ebd-corso-toggle')
    var notice = document.querySelector('.corso-notice')

    if (!toggle || !notice) return

    toggle.addEventListener('click', function () {
      notice.style.display = notice.style.display === 'block' ? 'none' : 'block'
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ebd-product-dropdowns"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('.ebd-product-dropdowns .dropdown-toggle');

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var single = toggle.closest('.dropdown-single');
      single.classList.toggle('active');
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ebd-product-tabs"] && !Shopify.designMode) return;
  try {
    const tabs = document.querySelectorAll('.product-tabs .tab');
  const tabContents = document.querySelectorAll('.product-tabs .tab-content-single');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab-id');

      tabs.forEach(t => t.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      this.classList.add('active');
      document.querySelector(`.tab-content-single[data-tab-id="${tabId}"]`).classList.add('active');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
